import React from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "./permissionHelper";

const PermissionWrapper = ({ name, children }) => {
  const permissionsData = useSelector(
    (state) => state.rolePermissionReducer.userPermissionData
  );

  const allowed = React.useMemo(
    () => hasPermission(permissionsData, name),
    [permissionsData, name]
  );

  if (!allowed) return null;

  return <>{children}</>;
};

export default PermissionWrapper;


